import { isObject } from "lodash-es";

export function xmlToJson(node: any): any {
  const obj: any = {};

  if (node.attributes?.length) {
    for (let attr of node.attributes) {
      obj[`@${attr.name}`] = attr.value;
    }
  }

  for (let child of node.childNodes) {
    if (child.nodeType === 1) {
      const name = child.nodeName;
      if (!obj[name]) {
        obj[name] = xmlToJson(child);
      } else {
        if (!Array.isArray(obj[name])) {
          obj[name] = [obj[name]];
        }
        obj[name].push(xmlToJson(child));
      }
    } else if (child.nodeType === 3 && child.nodeValue.trim()) {
      obj["#text"] = child.nodeValue.trim();
    }
  }

  return obj;
}

export function parseFacturaXml(xmlString: string): {
  origen: string;
  datos: any;
} {
  const parser = new DOMParser();
  const xml = parser.parseFromString(xmlString, "text/xml");
  const rootNode = xml.documentElement.nodeName;
  const xmlText = xmlString.toLowerCase();
  const json = xmlToJson(xml.documentElement);

  const isCostaRica =
    rootNode.includes("FacturaElectronica") ||
    rootNode.includes("TiqueteElectronico");

  if (isCostaRica) {
    return { origen: "Costa Rica", datos: json };
  }

  // ❌ Lanzamos un error si no es Costa Rica
  throw new Error(
    "Solo se pueden procesar facturas electrónicas de Costa Rica"
  );
}

export function parseXmlToJson(xmlString: string): any {
  const parser = new DOMParser();
  const xml = parser.parseFromString(xmlString, "text/xml");
  return xmlToJson(xml.documentElement);
}

export function extractDataFromFactura(origen: string, datos: any) {
  let encabezado: any = {},
    detalles: any[] = [],
    notas = "",
    montos: any = { impuestos: 0, descuento: 0 };

  try {
    switch (origen) {
      case "Costa Rica": {
        const fe =
          datos?.FacturaElectronica || datos?.TiqueteElectronico || datos;
        const emisor = fe?.Emisor?.Nombre?.["#text"] || "Desconocido";
        const nombreComercial = fe?.Emisor?.NombreComercial?.["#text"] || "";

        const lineasRaw = fe?.DetalleServicio?.LineaDetalle;
        const lineas = Array.isArray(lineasRaw) ? lineasRaw : [lineasRaw];

        detalles = lineas.map((linea: any) => {
          const impuesto = parseFloat(linea?.Impuesto?.Monto?.["#text"] || 0);
          montos.impuestos += impuesto;
          return {
            detalle: linea?.Detalle?.["#text"] || "",
            cantidad: parseFloat(linea?.Cantidad?.["#text"] || 0),
            precio: parseFloat(linea?.PrecioUnitario?.["#text"] || 0),
          };
        });

        encabezado = {
          fecha: fe?.FechaEmision?.["#text"] || "",
          numeroDeDocumento: fe?.NumeroConsecutivo?.["#text"] || "",
          origen: emisor,
          nombreComercial,
          descripcion: detalles[0]?.detalle || "",
          categoria: fe?.CodigoActividad?.["#text"] || "",
        };

        notas = fe?.Otros?.OtroTexto?.["#text"] || "";
        montos.descuento = parseFloat(
          fe?.ResumenFactura?.TotalDescuentos?.["#text"] || 0
        );
        break;
      }

      default: {
        // No se debe ejecutar, pero lo dejamos para control
        encabezado = {
          fecha: "",
          numeroDeDocumento: "",
          origen: "",
          nombreComercial: "",
          descripcion: "",
          categoria: "",
        };
        detalles = [];
        break;
      }
    }
  } catch (err) {
    console.error("Error parsing factura:", err);
  }

  return { encabezado, notas, detalles, montos };
}
